var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0748 8.76273C62.8855 7.74673 65.1148 7.74673 66.9228 8.76273C75.8695 13.7841 102.792 28.8987 111.741 33.9201C113.552 34.9334 114.667 36.8107 114.667 38.8427C114.667 48.8854 114.667 79.1121 114.667 89.1547C114.667 91.1867 113.552 93.0641 111.741 94.0801C102.795 99.1014 75.8722 114.216 66.9228 119.237C65.1122 120.253 62.8828 120.253 61.0748 119.237C52.1282 114.216 25.2055 99.1014 16.2562 94.0801C14.4482 93.0641 13.3335 91.1894 13.3335 89.1574C13.3335 79.1147 13.3335 48.8881 13.3335 38.8454C13.3335 36.8134 14.4482 34.9361 16.2588 33.9201C25.2028 28.8987 52.1308 13.7841 61.0748 8.76273Z",
    fill: "#00549D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1442 91.744C13.4348 90.7947 13.3335 89.8934 13.3335 88.68C13.3335 78.696 13.3335 48.6427 13.3335 38.656C13.3335 36.6347 14.4455 34.768 16.2508 33.76C25.1655 28.768 51.9975 13.7414 60.9122 8.74669C62.7175 7.73602 65.1628 7.75735 66.9682 8.76802C75.8828 13.76 102.624 28.6587 111.539 33.6507C112.259 34.056 112.808 34.544 113.299 35.1867L14.1442 91.744Z",
    fill: "#0086D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9998 26.6667C84.6052 26.6667 101.333 43.3948 101.333 64.0001C101.333 84.6054 84.6052 101.333 63.9998 101.333C43.3945 101.333 26.6665 84.6054 26.6665 64.0001C26.6665 43.3948 43.3945 26.6667 63.9998 26.6667ZM63.9998 45.3334C74.3012 45.3334 82.6665 53.6961 82.6665 64.0001C82.6665 74.3014 74.3012 82.6668 63.9998 82.6668C53.6985 82.6668 45.3332 74.3014 45.3332 64.0001C45.3332 53.6961 53.6958 45.3334 63.9998 45.3334Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.293 35.2134C114.669 36.5014 114.643 38.4427 114.643 39.9707C114.643 50.0907 114.557 78.8747 114.667 88.9947C114.677 90.0507 114.328 91.1627 113.805 92L62.9146 64L113.293 35.2134Z",
    fill: "#0075C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6665 56H87.9998V72H82.6665V56ZM101.333 56H106.667V72H101.333V56Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3335 61.3333H93.3335V66.6666H77.3335V61.3333ZM96.0002 61.3333H112V66.6666H96.0002V61.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c++.a4f728721461f1cde759cd7d6460e86d.svg";
export { ForwardRef as ReactComponent };